import Sidebar from "../components/Sidebar";
import '../styles/main.css';
import {Outlet} from "react-router-dom";
import {useState} from "react";
import {HomeContext} from "../context/HomeContext";

const Home = () => {

    const [newChat, setNewChat] = useState(false);

    const [chats, setChats] = useState([])

    const [query, setQuery] = useState("")

    return (
        <div className={"wrapper"}>
            <HomeContext.Provider value={{newChat, setNewChat, query, setQuery, chats, setChats}}>
                <Sidebar/>
                <Outlet/>
            </HomeContext.Provider>
        </div>
    )
}

export default Home;